import React from "react";

function HumanTraffic() {
    return (
        <div>
            HumanTraffic
        </div>
    );
}

export default HumanTraffic;